"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var button_1 = require("./button");
var icon_1 = require("./icon");
var Columns_1 = require("./Columns");
var Input_1 = require("./Input");
// Needed in order to correctly pass typing info to the any table in typescript
// See the demo app for usage
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Table.prototype.render = function () {
        return React.createElement(StyledTable, __assign({}, this.props));
    };
    return Table;
}(React.PureComponent));
exports.Table = Table;
exports.BasicFilterDropdown = function (_a) {
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
    return (React.createElement(DropWrap, null,
        React.createElement(DropDown, { gridTemplateColumns: '1fr 1fr' },
            React.createElement(InputArea, { placeholder: 'Search', value: selectedKeys[0], onChange: function (e) { return setSelectedKeys(e.target.value ? [e.target.value] : []); }, onPressEnter: confirm }),
            React.createElement(button_1.Button, { variant: "primary", onClick: confirm, icon: "search" }, "Search"),
            React.createElement(button_1.Button, { onClick: clearFilters }, "Reset"))));
};
exports.FilterIcon = function (filtered) { return React.createElement(SearchIcon, { filtered: filtered, type: "search" }); };
// Needed in order to correctly pass typing info to the any table in typescript
// https://github.com/styled-components/styled-components/issues/1803
var StyledTable = styled_components_1.default(antd_1.Table)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n"], ["\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n"])), function (props) { return props.theme.palette.background.light; }, function (props) { return props.theme.palette.border.main; });
var SearchIcon = styled_components_1.default(icon_1.Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &&& {\n        color: ", ";\n    }\n"], ["\n    &&& {\n        color: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme, filtered = _a.filtered;
    return (filtered ? theme.palette.primary.main : null);
});
var DropWrap = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 14rem;\n"], ["\n    width: 14rem;\n"])));
var DropDown = styled_components_1.default(Columns_1.Columns)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", ";\n    grid-gap: ", ";\n"], ["\n    padding: ", ";\n    grid-gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm;
});
var InputArea = styled_components_1.default(Input_1.Input)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    grid-column: 1 / span 2;\n"], ["\n    grid-column: 1 / span 2;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Table.js.map